import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Simple spinning loader. */
@Component({
  selector: 'app-spinner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span [style.width.px]="size" [style.height.px]="size"
      [style.border]="border" [style.border-top-color]="color"
      style="border-radius:50%;display:inline-block;animation:spin 0.7s linear infinite"></span>`,
})
export class SpinnerComponent {
  @Input() size = 22;
  @Input() color = 'var(--brand)';
  get border(): string {
    return `${Math.max(2, this.size / 9)}px solid color-mix(in srgb, ${this.color} 22%, transparent)`;
  }
}
